import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AdFormatFilterBody = _resolveComponent("AdFormatFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "ad_formats",
    ref: "adFormatFilterItem",
    icon: "LayoutIcon",
    title: $options.getAdFormatTitle,
    selectedTitle: $options.getAdFormatSelectedTitle,
    selectedCount: $props.ad_formats?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_AdFormatFilterBody, {
      title: "Ad Format",
      selected: $props.ad_formats?.filterState?.selected,
      isModified: $props.ad_formats.isModified,
      pendingChanges: $props.ad_formats.pendingChanges,
      isSearching: $props.ad_formats.isSearching,
      keyword: $props.ad_formats.keyword,
      list: $props.ad_formats.displayList,
      onClear: $options.handleClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.ad_formats.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: $options.onApply,
      onSearch: $options.handleAdFormatSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.adFormatFilterItem?.closeDropdown
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}